<template>
  <div class="landing-cnt row">
    <div class="bg-image"></div>
    <div class="col-12 d-xl-none d-lg-flex main-block-xs"></div>
    <div class="text-block-ctn col-xl-6 col-12 d-flex my-auto">
      <div class="text-ctn my-auto">
        <h1 v-html="$t('abogalitypro.title')"></h1>
        <p>
          {{ $t('abogalitypro.subtitle')}}
        </p>
        <div class="btn-cnt">
          <base-button class="mt-2 mt-md-5 fixed-width" white shadow @click="$helpers.goToSection('contact-form')" backgroundColor="#FFFFFF">{{ $t('abogalitypro.request-demo') }}</base-button>
          <base-button class="mt-3 mt-md-5 fixed-width d-block d-md-inline-block" @click="() => { $router.push('/inicio-sesion') }">{{ $t('login-wrd') }}</base-button>
        </div>
      </div>
    </div>
    <div class="learn-more" @click="$helpers.goToSection('contact-form')" v-if="!$store.getters['session/isLogged']">
      <span>{{ $t('more-info') }}</span>
    </div>
  </div>
  <!-- <div class="landing-cnt row">
    <div class="bg-img"></div>
    <div class="main-block col">
      <h1>{{ $t('main-block-h1') }}</h1>
      <div class="btn-cnt">
          <base-button white shadow :href="$helpers.get360AppUrl()">{{ $t('login.sign-in') }}</base-button>
      </div>
    </div>
    <div class="learn-more" @click="goToSection('integral-solutions')">
      <span>{{ $t('know-more-btn') }}</span>
    </div>
  </div> -->
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
/* @import '../../../../static-appopensalud/css/openlegal/colors.scss';
@import '../../../../static-appopensalud/css/public/views/360.scss'; */

  .landing-cnt .bg-image {
    @include desktop {
      background-image: url('../../../../static-appopensalud/img/bgs/patterns-bg-2.jpg'),linear-gradient(90deg, #FFFFFF, transparent);
      background-blend-mode: lighten;
      width: 100vw;
      background-size: 100vw;
    }

    @include mobile {
      background-image: url('../../../../static-appopensalud/img/bgs/patterns-bg-2.jpg'), 
      linear-gradient(180deg, #ffffff96, transparent);
      background-blend-mode: color;
    }
  }

  .fixed-width {
    width: 160px;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/abogalitypro/AbogalityMainBlock.vue